@if (label()) {
  <span class="range-slider__label">{{ label() }}</span>
}
<div class="slider-row" [class.slider-row--with-icons]="iconStart() || iconEnd()">
  @if (iconStart()) {
    <odl-icon [name]="iconStart()!"></odl-icon>
  }
  <input
    #sliderInput
    type="range"
    class="slider"
    [attr.aria-label]="ariaLabel()"
    [disabled]="isDisabled()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (mouseenter)="isTooltipVisible.set(true)"
    (mouseleave)="isTooltipVisible.set(false)"
    (focus)="isTooltipVisible.set(true)"
  />
  @if (resolvedTooltipText() !== undefined && isTooltipVisible()) {
    <div class="slider__tooltip" [style.inset-inline-start]="tooltipLeft()">
      {{ resolvedTooltipText() }}
    </div>
  }
  @if (iconEnd()) {
    <odl-icon [name]="iconEnd()!"></odl-icon>
  }
</div>
